import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Actions } from '../actions';

export const useAuthModalActions = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const handleLoginClick = React.useCallback(() => {
    dispatch(Actions.closeMobileDrawer());
    dispatch(Actions.showModal('login', pathname));
  }, [dispatch, pathname]);

  const handleRegisterClick = React.useCallback(() => {
    dispatch(Actions.closeMobileDrawer());
    dispatch(Actions.showModal('register', pathname));
  }, [dispatch, pathname]);

  return {
    onLoginClick: handleLoginClick,
    onRegisterClick: handleRegisterClick,
  };
};
